import type { CSSProperties } from 'react'
import styles from './BorderBeam.module.scss'

interface BorderBeamProps {
  /** Length of the traveling gradient blob, in px. */
  size?: number
  /** Time for one full lap, in seconds. */
  duration?: number
  /** Blob anchor position along its path, in percent. */
  anchor?: number
  /** Border thickness, in px. */
  borderWidth?: number
  colorFrom?: string
  colorTo?: string
  /** Animation start offset (e.g. "-3s" to desync multiple beams). */
  delay?: string
}

/**
 * Decorative animated border light. Render as the last child of a
 * `position: relative` element; it fills the box and traces its border.
 */
const BorderBeam: React.FC<BorderBeamProps> = ({
  size = 60,
  duration = 8,
  anchor = 90,
  borderWidth = 1.5,
  colorFrom = '#ffffff',
  colorTo = '#888888',
  delay = '0s',
}) => {
  const style = {
    '--beam-size': size,
    '--beam-duration': duration,
    '--beam-anchor': anchor,
    '--beam-border-width': borderWidth,
    '--beam-color-from': colorFrom,
    '--beam-color-to': colorTo,
    '--beam-delay': delay,
  } as CSSProperties

  return <span className={styles.beam} style={style} aria-hidden="true" />
}

export default BorderBeam
